










































































import { Component, Vue } from 'vue-property-decorator';
import { SysModule } from '@/store/modules/sys'
import { AppModule } from '@/store/modules/app';
import UserDto from '@/models/Users/UserDto'
import IconConstants from '@/lib/iconConstants';
import GiganautVue from '@/components/Shared/GiganautVue';
import { VuetifyConfirmObject } from 'vuetify-confirm';

@Component({
  name: 'WorkerUserList',
  components: { }
})
export default class extends GiganautVue {
    
    public currentIndex = 0;

    async created() {
    }

    async updateCurrentUser(user: UserDto) {
        SysModule.updateCurrentWorkerUser(user);
    }

    get currentUser() {
        return SysModule.currentWorkerUser;
    }

    get users() {
        return SysModule.workerUsers;
    }

    async triggerPasswordReset(user: UserDto) {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "SEND",
            buttonFalseText: "CANCEL",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to send a password reset link to ' + user.username + '?', options);
        if (result) {
            await SysModule.triggerPasswordReset(user.id);
        }
    }

    // async deleteAgencyUser(user: AgencyUserDto) {
    // const options: VuetifyConfirmObject = {
    //         buttonTrueText: "DELETE",
    //         buttonFalseText: "CANCEL",
    //         buttonTrueColor: "primary",
    //         buttonFalseColor: "primary",
    //     }
    //     const result = await this.$confirm('Are you sure you want to delete the user ' + user.person.firstName + ' ' + user.person.lastName + '?', options);
    //     if (result) {
    //         const request = new UpdateAgencyUserStatusRequest();
    //         request.updatedAt = user.updatedAt;
    //         request.status = AgencyUserStatusEnum.Deleted;
    //         await AgencyModule.deleteAgencyUser(request);
    //     }
  //}
}
